import { useEffect, useState } from "react";

import { getGoogleLocationDetailsByCoordinates } from "eventLocation/googlePlaces";
import {
  isCoordinateLocationValue,
  resolveEventLocationValue,
} from "eventLocation/resolveLocationValue";

export function useReadableEventLocationText(text?: string) {
  const [resolvedText, setResolvedText] = useState<string | undefined>();

  useEffect(() => {
    let isCancelled = false;
    setResolvedText(undefined);

    if (!text || !isCoordinateLocationValue(text)) {
      return () => {
        isCancelled = true;
      };
    }

    getGoogleLocationDetailsByCoordinates(text).then((details) => {
      if (isCancelled || !details) {
        return;
      }

      setResolvedText(resolveEventLocationValue(text, details));
    });

    return () => {
      isCancelled = true;
    };
  }, [text]);

  return resolvedText || text;
}
